// @flow
import React from 'react'

import TmBanner from './ProviderPreviews/TmBanner'
import VkPreview from './ProviderPreviews/VkPreview'
import MultiFacebookPreview from './ProviderPreviews/MultiFacebookPreview'
import InstagramPreview from './ProviderPreviews/InstagramPreview'
import FacebookMobile from './ProviderPreviews/FacebookMobile'
import FacebookPreview from './ProviderPreviews/FacebookPreview'
import TmLenta from './ProviderPreviews/TmLenta'
import GooglePreview from './ProviderPreviews/GooglePreview'
import GoogleSimple from './ProviderPreviews/GoogleSimple'
import TmPreview from './ProviderPreviews/TmPreview'
import TmPreviewMulti from './ProviderPreviews/TmPreviewMulti'
import VkPromoPost from './ProviderPreviews/VkPromoPost'
import type { Crop, Image, Media, PersistedImage, Public } from '../types'
import { PreviewNames as previewNames } from '../constants'

export type PreviewData = {|
  url: string,
  title: string,
  vkTitle: string,
  fbTitle: string,
  description: string,
  vkExtendedDescription: string,
  fbExtendedDescription: string,
  image: ?Media,
  vkImageCrop: ?Crop,
  tmImageCrop: ?Crop,
  fbImageCrop: ?Crop,
  glImageCrop: ?Crop,
  linkTitle: string,
  logoImage: ?Media,
  logoImageCrop: ?Crop,
  vkPublic: Public,
  fbPublic: Public,
  video: ?Media,
  vkHasButton: boolean,
  tmSmallImage: ?Image | ?PersistedImage,
  tmSmallImageCrop: ?Crop,
  tmLinkButton: string,
  instagramImage: ?Image,
  instagramImageCrop: ?Crop,
  fbLinkButton: string,
  vkLinkButton: string,
  fbThumbnailImage: ?Image,
  fbThumbnailImageCrop: ?Crop,
  vkBigImage: ?Image
|}

const t = {
  fill_in_form: 'Оставьте заявку',
  leadform_default_button_text: 'Открыть'
}

export default function NamedPreview(props: {| name: string, data: PreviewData |}) {
  const { name, data } = props

  if (name === previewNames.vk_preview) {
    return (
      <VkPreview
        title={data.vkTitle || data.title}
        description={data.description}
        url={data.url}
        image={data.image}
        imageCrop={data.vkImageCrop}
      />
    )
  } else if (name === previewNames.vk_leadform) {
    return (
      <VkPromoPost
        title={data.vkTitle}
        linkTitle={data.linkTitle}
        description={data.vkExtendedDescription}
        url={t.fill_in_form}
        publicInfo={data.vkPublic}
        linkButton={t.leadform_default_button_text}
        image={data.image || data.video}
        imageCrop={data.vkImageCrop}
        logoImage={data.logoImage}
        logoImageCrop={data.logoImageCrop}
        hasButton
      />
    )
  } else if (name === previewNames.tm_banner) {
    return (
      <TmBanner
        title={data.title}
        description={data.description}
        url={data.url}
        image={data.tmSmallImage || data.image}
        imageCrop={data.tmSmallImageCrop || data.tmImageCrop}
        linkButton={data.tmLinkButton}
      />
    )
  } else if (name === previewNames.multi_facebook_preview) {
    return (
      <MultiFacebookPreview
        title={data.fbTitle || data.title}
        description={data.fbExtendedDescription}
        publicInfo={data.fbPublic}
        url={data.url}
        linkButton={data.fbLinkButton}
        image={data.image || data.fbThumbnailImage || data.video}
        imageCrop={data.fbImageCrop || data.fbThumbnailImageCrop}
      />
    )
  } else if (name === previewNames.instagram_preview) {
    return (
      <InstagramPreview
        title={data.fbTitle || data.title}
        description={data.fbExtendedDescription}
        publicInfo={data.fbPublic}
        image={data.instagramImage || data.image}
        imageCrop={data.instagramImageCrop || data.fbImageCrop}
        linkButton={data.fbLinkButton}
      />
    )
  } else if (name === previewNames.facebook_mobile) {
    return (
      <FacebookMobile
        title={data.fbTitle || data.title}
        description={data.fbExtendedDescription}
        publicInfo={data.fbPublic}
        linkButton={data.fbLinkButton}
        image={data.image}
        imageCrop={data.fbImageCrop}
      />
    )
  } else if (name === previewNames.facebook_preview) {
    return (
      <FacebookPreview
        title={data.fbTitle || data.title}
        description={data.description}
        url={data.url}
        image={data.image || data.fbThumbnailImage || data.video}
        imageCrop={data.fbImageCrop || data.fbThumbnailImageCrop}
      />
    )
  } else if (name === previewNames.tm_lenta) {
    return (
      <TmLenta
        title={data.title}
        description={data.description}
        url={data.url}
        image={data.image || data.video}
        imageCrop={data.tmImageCrop}
        logoImage={data.logoImage}
        logoImageCrop={data.logoImageCrop}
      />
    )
  } else if (name === previewNames.google_preview) {
    return (
      <GooglePreview
        url={data.url}
        title={data.title}
        description={data.description}
        image={data.image || data.video}
        imageCrop={data.glImageCrop}
      />
    )
  } else if (name === previewNames.google_simple) {
    return (
      <GoogleSimple
        title={data.title}
        url={data.url}
        image={data.image || data.video}
        imageCrop={data.glImageCrop}
      />
    )
  } else if (name === previewNames.tm_preview) {
    return (
      <TmPreview
        title={data.title}
        description={data.description}
        url={data.url}
        image={data.image}
        imageCrop={data.tmImageCrop}
      />
    )
  } else if (name === previewNames.tm_preview_multi) {
    return (
      <TmPreviewMulti
        title={data.title}
        description={data.description}
        url={data.url}
        image={data.tmSmallImage || data.image}
        imageCrop={data.tmSmallImageCrop || data.tmImageCrop}
      />
    )
  } else if (name === previewNames.vk_promopost) {
    return (
      <VkPromoPost
        title={data.vkTitle}
        linkTitle={data.linkTitle}
        description={data.vkExtendedDescription}
        url={data.url}
        publicInfo={data.vkPublic}
        linkButton={data.vkLinkButton}
        image={data.vkBigImage || data.image || data.video}
        imageCrop={data.vkImageCrop}
        logoImage={data.logoImage}
        logoImageCrop={data.logoImageCrop}
        hasButton={data.vkHasButton}
      />
    )
  }

  return <div>Unknown preview name "{name}"</div>
}
